import { useDispatch, useSelector } from 'react-redux'
import { State } from '../../../../reducers'
import { FACTURACION_TYPES } from '../../../../constants/facturacion.types'
import DescuentoGlobalBase from '../../../../components/DescuentoGlobal/DescuentoGlobal'

export default function DescuentoGlobalFactura() {
  const dispatch = useDispatch()
  const { formDescuentoGlobal, calculosArrayProductos, arrayProductos } = useSelector((state: State) => state.facturacion)

  return (
    <DescuentoGlobalBase
      form={formDescuentoGlobal}
      onChange={(cambios) => dispatch({ type: FACTURACION_TYPES.FORMDESCUENTOGLOBAL_HANDLE_CHANGE, payload: cambios })}
      descuentoAplicado={calculosArrayProductos.descuentoGlobal}
      error={calculosArrayProductos.descuentoGlobalError}
      deshabilitado={arrayProductos.length === 0}
    />
  )
}
